import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAuth } from '@/hooks/use-auth'
import { takeReturnPath } from '@/auth/session-persistence'
import { Loader2 } from 'lucide-react'

export const Route = createFileRoute('/callback')({
  staticData: { title: 'Signing in' },
  component: CallbackPage,
})

function CallbackPage() {
  const { isAuthenticated, isLoading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading) return
    if (isAuthenticated) {
      // Clear the silent-SSO attempt flag so that if this tab later loses its
      // cache (mobile tab killed, ETP/ITP purge) we'll attempt silent SSO
      // again instead of going straight to the manual button.
      try {
        sessionStorage.removeItem('msal:silent-sso-attempted')
      } catch {
        // ignore
      }
      const returnPath = takeReturnPath()
      if (returnPath) navigate({ href: returnPath, replace: true })
      else navigate({ to: '/dashboard' })
    } else {
      // handleRedirectPromise completed without authenticating us (e.g. PKCE
      // state lost, user cancelled, prompt=none returned login_required).
      // Fall back to the login page; the silent-SSO flag is already set so
      // login.tsx will show the manual button instead of looping.
      navigate({ to: '/login' })
    }
  }, [isLoading, isAuthenticated, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  )
}
